import Assinar from './Assinar';
import Historico from './Historico';

export const EmprestimosEpiHistorico = Historico;
export const EmprestimosEpiAssinar = Assinar;
